module.exports = __webpack_public_path__ + "img/linker_small.d420943c.png";